import { Component } from '@angular/core';
import { ORCIDResearcherUrlEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Researcher Urls') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidresearcherurl-form',
    templateUrl: './orcidresearcherurl.form.component.html'
})
export class ORCIDResearcherUrlFormComponent extends BaseFormComponent {
    public record!: ORCIDResearcherUrlEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

